module.exports = __webpack_public_path__ + "static/img/13.8be46ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/13.png
// module id = 02Ls
// module chunks = 0